<template>
	<div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" height="calc(100vh - 190px)">
				<el-table-column prop="product.name" label="产品名称">
				</el-table-column>
				<el-table-column label="已激活/已购">
					<template slot-scope='scope'>
						<p><span class="yellow">{{scope.row.active}}</span> / {{scope.row.total}}</p>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope='scope'>
						<router-link v-if='scope.row.active != 0' class='blue' :to="{path:'/commodity/statisticalDetail',query:{id:scope.row.product.id}}">销售详情</router-link>
						<el-button v-else type="text" disabled>销售详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye" v-if="false">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>		
	</div>
</template>

<script>
	import { entityProductStat } from '@/axios/api.js'
	export default {
		data() {
			return {
				input10: '',
				tableData: [],
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:0,//当前页	
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getData()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val-1) * this.eachPage;
				console.log(val)
				this.getData()
			},					
			getData(){
				var data={
					start:this.indexPage,
					count:this.eachPage,
				}
				entityProductStat(data)
				.then( res => {
				    console.log(res);
					this.tableData=res.data.obj
					this.allpage=res.data.total;

				})
				.catch(err => {
				    console.log(err);
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style scoped="scoped">
	.searchBox {
		margin: 20px 0;
	}
</style>



// WEBPACK FOOTER //
// src/views/card/statistical.vue